module.exports = __webpack_public_path__ + "static/media/credit.b3e41810.svg";